import {useState} from 'react'
import {useMutation, UseMutateFunction} from 'react-query'
import {useNavigate} from 'react-router-dom'

import TSApi from 'api/TS/TSApi'
import {useSnackBar} from 'hoc/SnackbarHandler'
import {FormErrorPayload, FormSuccessPayload} from '_helper/_types'
import {_getError} from '_helper/_getError'
import type {Entity} from '_helper/_types'

export type EntityPayload = {
  ...FormSuccessPayload,
  entity_id: number,
}

/**
 * To create risk event
 * @return {Promise<any>}
 */
export async function createEntity(formDetails): EntityPayload | FormErrorPayload {
  const {data} = await TSApi.post(`entities/`, {
    entity_code: formDetails.entity_code,
    entity_name: formDetails.entity_name,
    currency: formDetails.currency,
    country_id: formDetails.country_id,
    segment_id: formDetails.segment_id,
  })

  return data
}

interface UseCreateEntity {
  mutate: UseMutateFunction;
  isLoading: boolean;
  errors: [];
}

export function useCreateEntity(): UseCreateEntity {
  const {setSnackBar} = useSnackBar()
  const navigate = useNavigate()
  const [errors, setErrors] = useState(null)

  const {mutate, isLoading} = useMutation(
    (entityDetails: Entity) => createEntity(entityDetails),
    {
      onSuccess: (result: EntityPayload | FormErrorPayload) => {
        setSnackBar({
          open: true,
          type: result.status === 'SUCCESS' ? 'success' : 'error',
          message:
            result.status === 'SUCCESS'
              ? result.message
              : 'Validation failed! Please check those fields that are in red.',
        })

        if (result.status === 'SUCCESS') {
          navigate(`/Metadata/Entity/${result.entity_id}`)
        } else {
          setErrors(_getError(result.errors))
        }
      },
    }
  )

  return {mutate, isLoading, errors}
}
